<template>
  <nav>
    <v-navigation-drawer v-model="drawer" app src="@/assets/bannerTopo.png">
      <v-list dense>
        <v-list-item class="px-14">
          <v-img :aspect-ratio="16 / 9" src="@/assets/logoBranco.png"></v-img>
        </v-list-item>

        <v-list-item
          link
          v-for="link of links"
          v-bind:key="link.title"
          router
          :to="link.route"
        >
          <v-list-item-action>
            <v-icon medium color="white">{{ link.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-content class="white--text">
            <v-list-item-title>{{ link.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group v-if="user.perfil.id == 1" no-action>
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon medium color="white">mdi-cog</v-icon>
            </v-list-item-action>

            <v-list-item-content class="white--text">
              <v-list-item-title>Área administrativa</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/area-administrativa/cadastro">
            <v-list-item-action>
              <v-icon medium color="white white--text"
                >mdi-database-plus</v-icon
              >
            </v-list-item-action>

            <v-list-item-content class="white--text">
              <v-list-item-title>Cadastro</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/area-administrativa/relatorio">
            <v-list-item-action>
              <v-icon medium color="white">mdi-note-text-outline</v-icon>
            </v-list-item-action>

            <v-list-item-content class="white--text">
              <v-list-item-title>Relatório</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item link @click="tryToLogout()">
          <v-list-item-action>
            <v-icon medium color="white">mdi-logout</v-icon>
          </v-list-item-action>

          <v-list-item-content class="white--text">
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app light class="header">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-items>
        <img
          v-show="!drawer"
          src="@/assets/logoBar.png"
          style="height: inherit;"
        />
      </v-toolbar-items>

      <v-spacer></v-spacer>

      <v-btn text>
        <span>{{ user.nome }}</span>
        <v-icon color="gray" medium right>mdi-chevron-down</v-icon>
      </v-btn>
    </v-app-bar>
  </nav>
</template>
<script>
  import { routes } from '../../routes';
  import { mapState, mapActions } from 'vuex';

  export default {
    data: () => ({
      routes,
      bdName: '',
      user: {
        perfil: {
          id: '',
        },
      },
      drawer: null,
      links: [
        { icon: 'mdi-home', title: 'Dashboard', route: '/dashboard' },
        { icon: 'mdi-pencil', title: 'Novo teste', route: '/novo-teste' },
        {
          icon: 'mdi-notebook-multiple',
          title: 'Meus testes',
          route: '/meus-testes',
        },
        /*{
          icon: 'mdi-book-variant',
          title: 'Minhas aulas',
          route: '/minhas-aulas',
        },*/
        {
          icon: 'mdi-download',
          title: 'Provas de concursos',
          route: { name: 'provasConcursos' },
        },
        { icon: 'mdi-account', title: 'Meu cadastro', route: '/meu-cadastro' },
        { icon: 'mdi-chat', title: 'Fale Conosco', route: '/fale-conosco' },
      ],
      items: [
        {
          text: 'Área administrativa',
          disabled: false,
          href: '/area-administrativa',
        },
        {
          text: 'Cadastro',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Usuário',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
    }),
    mounted() {
      if (localStorage.getItem('auth.currentUser')) {
        this.user = JSON.parse(localStorage.getItem('auth.currentUser'));
      }
    },
    computed: {
      ...mapState('auth', ['currentUser']),
    },
    methods: {
      ...mapActions('auth', ['logout']),
      tryToLogout() {
        this.logout();
        this.$router.push({ path: '/', meta: { expiredToken: false } });
      },
    },
  };
</script>
<style scoped>
  .icnAdm:disabled {
    color: white !important;
  }
  .header {
    height: 68px;
    padding-top: 12px;
  }
</style>
